import { render, staticRenderFns } from "./TraderList.vue?vue&type=template&id=711b0c2b&scoped=true&"
import script from "./TraderList.vue?vue&type=script&lang=js&"
export * from "./TraderList.vue?vue&type=script&lang=js&"
import style0 from "./TraderList.vue?vue&type=style&index=0&id=711b0c2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711b0c2b",
  null
  
)

export default component.exports